// extracted by css-extract-rspack-plugin
export default {"contactDetailsGroup":"contactDetailsGroup-U9mqdV"};